module.exports = __webpack_public_path__ + "static/sport/bg3.67a65da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/bg3.png
// module id = QUaD
// module chunks = 0